/* iceberg-ui */
import { Text } from '@auviknetworks/iceberg-ui';

/*  tanstack  */
import { CellContext } from '@tanstack/react-table';

/*  Shared  */
import { getClientName } from 'application/Shared/Helpers/tenant';
import { ScheduledReport as ScheduledReportType } from 'application/Shared/types/scheduledReport';

/* Hooks */
import { useSession } from 'hooks/redux/Selectors/session';

/* React */
import React from 'react';

export const TenantNameCell = ({
    cell
}: CellContext<ScheduledReportType, string>): React.ReactElement => {
    const session = useSession();
    const clientName = getClientName({
        clientId: cell.getValue(),
        session
    });

    return <Text>{clientName}</Text>;
};
